export const ZINDEX_NAVIGATION = 1500;
export const ZINDEX_DEEPLINKS = 2000;
export const ZINDEX_OVERLAY_BG = 3000;
export const ZINDEX_MODAL = 4000;
export const ZINDEX_LOGO = 5000;
export const ZINDEX_COOKIE_BANNER = 5000;
export const ZINDEX_PAGE_BOTTOM_WRAP = 1000;



// WEBPACK FOOTER //
// ../src/client/styles/zIndex.js